import { TurnInto } from 'almanac-ui/icons'
import { Revision } from 'types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { RevisionAcceptAction, useAcceptRevision } from 'hooks/queries/layers/revisions/useAcceptRevision'
import { Button } from 'blaze-ui/Button'
import { useQueryClient } from 'react-query'
import { layersKeys } from 'hooks/queries/layers/layersKeys'
import ArrowSwitchHorizontal from 'blaze-ui/icons/20/ArrowSwitchHorizontal'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'

interface Props {
  revision: Revision
}

export const ReplaceSelectionButton = observer(({ revision }: Props) => {
  const { isMobile } = useResponsiveDesign()
  const { drawersStore } = useRootStore()
  const queryClient = useQueryClient()
  const { mutate: acceptRevision, isLoading } = useAcceptRevision(
    {
      articleKey: revision.layer.article_id,
      layerId: revision.layer.id,
      id: revision.id,
    },
    {
      onSuccess: () => {
        drawersStore.closeDrawer()
        queryClient.invalidateQueries(layersKeys.revision(revision.layer.id, revision.id))
      },
    },
  )

  const handleOnPress = () => {
    acceptRevision(
      { accept_action: RevisionAcceptAction.ReplaceSelection },
    )
  }

  return isMobile ? (
    <Button
      frontIcon={ArrowSwitchHorizontal}
      fullWidth
      variant="primary"
      size="lg"
      onPress={handleOnPress}
      isDisabled={isLoading}
    >
      Replace Selection with Suggestion
    </Button>
  ) : (
    <Button frontIcon={TurnInto} variant="primary" size="sm" onPress={handleOnPress} isDisabled={isLoading}>
      Replace Selection
    </Button>
  )
})
